// Language hints are shown on all code block so that users know what language
// they are looking at i.e. you can have a shell script block on a Java page
// This ensures that the hints are always visible unless the fallback language
// nav for the block is showing negating the need for this hint

export default function setLanguageHintVisibility(elem) {
  const $elem = $(elem);
  const visible = $elem.parent().has('menu[type="toolbar"]:visible').length;
  const method = visible ? 'hide' : 'show';
  return $elem.find('.lang-hint')[method]();
}
